import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const CASAVI_CONTACT_WHITELIST_CREATE_RESOURCE = "casavi-contact-whitelist" as const;
export const CASAVI_CONTACT_WHITELIST_CREATE_API_PATH = `/v1/${CASAVI_CONTACT_WHITELIST_CREATE_RESOURCE}` as const;

export type CasaviContactWhitelistCreateBody =
  paths[typeof CASAVI_CONTACT_WHITELIST_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type CasaviContactWhitelistCreateResponse =
  paths[typeof CASAVI_CONTACT_WHITELIST_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useCasaviContactWhitelistCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CasaviContactWhitelistCreateResponse, Error, CasaviContactWhitelistCreateBody>({
    mutationFn: async (casaviContactWhitelist: CasaviContactWhitelistCreateBody) => {
      const response = await alphartisApiAxios.post<CasaviContactWhitelistCreateResponse>(
        CASAVI_CONTACT_WHITELIST_CREATE_API_PATH,
        casaviContactWhitelist,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [CASAVI_CONTACT_WHITELIST_CREATE_RESOURCE],
      });
    },
  });
};
